import './App.css';

function App() {
  return (
    <div className="App">
      <h1>
        Privacy Policy for SecureDocs Manager
      </h1>
      <main>
        <section><p>This Privacy Policy governs the use of SecureDocs Manager, a mobile application designed for the offline management of important document folders.</p></section>
        <section>
          <h2>No Data Collection</h2>
          <p>SecureDocs Manager operates entirely offline and does not collect any personal identification information or data from users. We do not request, store, or transmit any user data, ensuring the utmost privacy and security for your important documents.</p>
        </section>
        <section>
          <h2>Document Management</h2>
          <p>SecureDocs Manager is specifically designed to help you manage and organize your important documents and folders securely. All document management activities occur solely on your device, and no data is shared or transmitted to external servers or third parties.</p>
        </section>
        <section>
          <h2>Information Security</h2>
          <p>While we do not collect or transmit user data, we are dedicated to safeguarding the security and privacy of your documents stored within the app. We have implemented appropriate security measures to ensure the protection of your sensitive information.</p>
        </section>
        <section>
          <h2>Changes to This Privacy Policy</h2>
          <p>SecureDocs Manager has the discretion to update this privacy policy at any time. When we do, we will revise the updated date at the bottom of this page. Please check this page periodically for any changes.</p>
        </section>
        <section>
          <h2>Contacting Us</h2>
          <p>If you have any questions about this Privacy Policy or your use of SecureDocs Manager, please contact us at <a
          className="App-link"
          href="mailto:1shyam2shyam@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          mail
        </a>.</p>
        </section>
      </main>
      <footer>
        <p>This document was last updated on 07/10/2023.</p>
      </footer>
    </div>

  );
}

export default App;
